// Antes del cambio (escrito por Yevhenii)
// const minMax = (value, min, max) => {
//   if (isNaN(value)) {
//     if (min === 0) {
//       return '';
//     }
//     return min;
//   }
//   let res = '';
//   if (!max) {
//     res = parseFloat(value) < parseFloat(min) ? parseFloat(min) : parseFloat(value);
//   } else {
//     res = Math.max(parseFloat(min), Math.min(parseFloat(max), Number(value)));
//   }
//   return res === 0 ? '' : res;
// };

// export default minMax;

const minMax = (value, min, max) => {
  const n = Number(value);
  const hasMin = min !== undefined && min !== null;
  const hasMax = max !== undefined && max !== null;

  // Si no es número válido → vacío
  if (!Number.isFinite(n)) return '';

  const minNum = hasMin ? Number(min) : -Infinity;
  const maxNum = hasMax ? Number(max) :  Infinity;

  // Clamp sin truthiness y SIN convertir 0 en ''
  if (n < minNum) return minNum;
  if (n > maxNum) return maxNum;
  return n;
};

export default minMax;